/**
 * ForAdmin
 * 
 * @Author: Focci
 * @Date: 2023-11-13 11:03:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-11-13 11:03:56
 */

'use client'

import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import useLogin from '@hook/useLogin'
import { useMemo } from 'react'
import { ADMIN_BASE_URL } from '@lib/config'

export default function ForAdmin({
  house = {}
}) {
  const th = useTranslations('house')
  const { isLogin, user } = useLogin()

  const editUrl = useMemo(() => `${ADMIN_BASE_URL}#/listing/${house.id}`, [house])
  
  if(!(isLogin && (user?.is_admin || user?.isAdmin))) {
    return null
  }

  return (
    <>
      <span>{`${th('propertyCode')}：${house.code}`}</span>
      <span>
        <a 
          href={editUrl}
          rel="noreferrer" 
          target="_blank" 
          className="text-primary font-medium"
        >
          EDIT
        </a>
      </span>
    </>
  )
}

ForAdmin.propTypes = {
  house: PropTypes.object,
}
